import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { RouterModule } from '@angular/router';
import { Breadcrumbs } from '../models';
import { LanguagePrefixPipe } from '@ca/ca-ng-core';
import { D4CActions, Selectors } from '../store';

@Component({
  selector: 'd4c-breadcrumbs',
  imports: [CommonModule, RouterModule, LanguagePrefixPipe],
  template: `
    @for (breadcrumb of breadcrumbs$ | async; track $index) {
      @if (breadcrumb.title){
      @if ($index === 0) {
        <a (click)="resetRole()" [routerLink]="breadcrumb.routerLink | languagePrefix | async">{{
          breadcrumb.title
        }}</a>
      } @else {
        <a [routerLink]="breadcrumb.routerLink | languagePrefix | async">{{ breadcrumb.title }}</a>
      }
      @if (!$last) {
        >
      }}
    }
  `,
})
export class BreadcrumbsComponent {
  private store = inject(Store<{ breadcrumbs: Breadcrumbs }>);

  breadcrumbs$: Observable<Breadcrumbs> = this.store.select(Selectors.selectBreadcrumbs);

  resetRole() {
    this.store.dispatch(D4CActions.SetRole({ role: null }));
  }
}
